export default __webpack_public_path__ + "static/media/empty-state-template-srp.8714f507.svg";